import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmt, fmtD, Btn, downloadCsvReport, downloadSimplePdf } from "../shared";
import { IMMEUBLES } from "../data";

export const RapportsPage = ({ residents, cotisations, charges, immId }) => {
  const [gen, setGen] = useState(null);
  const imm = IMMEUBLES.find(i => i.id === immId);
  const immResidents = residents.filter(r=>r.immId===immId);
  const immCotisations = cotisations.filter(c=>c.immId===immId);
  const immCharges = charges.filter(c=>c.immId===immId);
  const exportReport = async (report) => {
    setGen(report.title);
    await new Promise(r => setTimeout(r, 500));

    if (report.title === "Liste des copropriétaires") {
      downloadCsvReport(`coproprietaires-${imm?.slug || immId}.csv`, [
        ["Nom", "Prenom", "Email", "Appartement", "Solde", "Statut"],
        ...immResidents.map((resident) => [resident.nom, resident.prenom, resident.email, resident.apt, resident.solde, resident.statut]),
      ]);
    } else if (report.title === "Toutes les factures") {
      downloadCsvReport(`factures-${immId}.csv`, [
        ["Resident", "Type", "Montant", "Echeance", "Statut"],
        ...immCotisations.map((item) => [item.resident, item.type, item.montant, item.echeance, item.statut]),
      ]);
    } else if (report.title === "Balance des comptes") {
      downloadCsvReport(`balance-${immId}.csv`, [
        ["Categorie", "Valeur"],
        ["Coproprietaires", immResidents.length],
        ["Encaisse", immCotisations.filter(c => c.statut === "payé").reduce((a,c) => a + c.montant, 0)],
        ["Restant du", immCotisations.filter(c => c.statut !== "payé").reduce((a,c) => a + c.montant, 0)],
        ["Charges", immCharges.reduce((a,c) => a + c.montant, 0)],
      ]);
    } else if (report.title === "Relevés de comptes") {
      downloadSimplePdf(`releves-${immId}.pdf`, `Releves de comptes - ${imm?.nom || ""}`, immCotisations.map((item) => `${item.resident} | ${item.type} | ${item.statut} | ${item.montant} MAD`));
    } else if (report.title === "Procès-verbal AG") {
      downloadSimplePdf(`proces-verbal-${immId}.pdf`, `Proces verbal AG - ${imm?.nom || ""}`, [
        `Date d'export: ${new Date().toLocaleDateString("fr-FR")}`,
        `Lots: ${imm?.lots || 0}`,
        `Coproprietaires: ${immResidents.length}`,
        "Document de synthese genere depuis ResiFlow."
      ]);
    } else {
      downloadSimplePdf(`travaux-${immId}.pdf`, `Rapport des travaux - ${imm?.nom || ""}`, immCharges.map((item) => `${item.description} | ${item.cat} | ${item.montant} MAD`));
    }

    setGen(null);
  };
  const raps = [
    {icon:"📊",title:"Liste des copropriétaires",desc:"Avec soldes et coordonnées",type:"Excel",color:C.green},
    {icon:"💰",title:"Relevés de comptes",desc:"Historique par résident",type:"PDF",color:C.blue},
    {icon:"🧾",title:"Toutes les factures",desc:"Export comptable",type:"Excel",color:C.orange},
    {icon:"⚖️",title:"Balance des comptes",desc:"Débiteurs et créditeurs",type:"Excel",color:C.gold},
    {icon:"📋",title:"Procès-verbal AG",desc:"Compte-rendu assemblée",type:"PDF",color:C.navy},
    {icon:"🔧",title:"Rapport des travaux",desc:"État récapitulatif",type:"PDF",color:C.purple},
  ];

  return (
    <div>
      <div style={{marginBottom:22}}>
        <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Rapports & Exports</h2>
        <p style={{color:C.muted,fontSize:13}}>{imm?.nom}</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
        {raps.map((r, i) => (
          <div key={r.title} className="fu ch" style={{animationDelay:`${i*50}ms`,background:C.card,borderRadius:16,padding:20,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
            <span style={{fontSize:28,display:"block",marginBottom:9}}>{r.icon}</span>
            <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:4}}>{r.title}</h4>
            <p style={{fontSize:12,color:C.muted,marginBottom:16,lineHeight:1.5}}>{r.desc}</p>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{background:r.type==="Excel"?"#d1fae5":"#e0e7ff",color:r.type==="Excel"?"#065f46":"#3730a3",padding:"2px 9px",borderRadius:20,fontSize:10,fontWeight:700}}>{r.type}</span>
              <button className="btn" onClick={() => exportReport(r)} disabled={!!gen}
                style={{padding:"6px 13px",background:gen===r.title?C.muted:r.color,color:"#fff",borderRadius:9,fontWeight:600,fontSize:12}}>
                {gen===r.title?"⏳...":"⬇ Télécharger"}
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="fu" style={{animationDelay:"360ms",background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:24,marginTop:18}}>
        <h4 style={{fontSize:14,fontWeight:700,color:"#fff",marginBottom:12}}>📆 Récapitulatif — {imm?.nom}</h4>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
          {[
            ["Copropriétaires", residents.filter(r=>r.immId===immId).length],
            ["Lots", imm?.lots],
            ["Encaissé", fmt(cotisations.filter(c=>c.immId===immId&&c.statut==="payé").reduce((a,c)=>a+c.montant,0))],
            ["Charges", fmt(charges.filter(c=>c.immId===immId).reduce((a,c)=>a+c.montant,0))],
          ].map(([l,v]) => (
            <div key={l} style={{background:"rgba(255,255,255,.08)",borderRadius:11,padding:14}}>
              <p style={{color:"rgba(255,255,255,.4)",fontSize:11}}>{l}</p>
              <p style={{fontSize:20,fontWeight:800,fontFamily:"Syne",color:"#fff",marginTop:3}}>{v}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

